export const Employee = (json: IEmployee): IEmployeeModel => {
	const fromJSON = (itemJson: IEmployee) => {
		const { first_name, last_name, phone_number, created_at, role, locations, facilities, ...rest } = itemJson
		return {
			firstName: first_name,
			lastName: last_name,
			phoneNumber: phone_number,
			createdAt: created_at ? new Date(created_at) : null,
			role: role ? employeeRoles.find(r => r.value === role) || { value: role, label: role } : null,
			locations: locations || [],
			facilities: facilities || [],
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const employeeToJSON = (obj: Partial<IEmployeeModel>): IEmployeeJson => {
	const { firstName, lastName, phoneNumber, role, locations, facilities, ...rest } = obj
	return {
		first_name: firstName ?? undefined,
		last_name: lastName ?? undefined,
		phone_number: phoneNumber ?? undefined,
		role: role?.value ? role.value : undefined,
		...(locations ? { location_ids: locations.map(loc => loc.id) } : {}),
		...(facilities ? { facility_ids: facilities.map(facility => facility.id) } : {}),
		...rest,
	}
}

export const EmployeeLocation = (json: IEmployeeLocation): IEmployeeLocationModel => {
	const { created_at, updated_at, ...rest } = json

	return {
		...rest,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const EmployeeFacility = (json: IEmployeeFacility): IEmployeeFacilityModel => ({ ...json })
